export interface DocumentationImage {
  id: number;
  category: string;
  year: number;
  image: string;
}

export const documentationImage: DocumentationImage[] = [
  {
    id: 1,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-1.jpg",
  },
  {
    id: 2,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-2.jpg",
  },
  {
    id: 3,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-3.jpg",
  },
  {
    id: 4,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-4.jpg",
  },
  {
    id: 5,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-5.jpg",
  },
  {
    id: 6,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-6.jpg",
  },
  {
    id: 7,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-7.jpg",
  },
  {
    id: 8,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-8.jpg",
  },
  {
    id: 9,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-9.jpg",
  },
  {
    id: 10,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-10.jpg",
  },
  {
    id: 11,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-11.jpg",
  },
  {
    id: 12,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-12.jpg",
  },
  {
    id: 13,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-13.jpg",
  },
  {
    id: 14,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-14.jpg",
  },
  {
    id: 15,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-15.jpg",
  },
  {
    id: 16,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-16.jpg",
  },
  {
    id: 17,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-17.jpg",
  },
  {
    id: 18,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-18.jpg",
  },
  {
    id: 19,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-19.jpg",
  },
  {
    id: 20,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-20.jpg",
  },
  {
    id: 21,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-21.jpg",
  },
  {
    id: 22,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-22.jpg",
  },
  {
    id: 23,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-23.jpg",
  },
  {
    id: 24,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-24.jpg",
  },
  {
    id: 25,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-25.jpg",
  },
  {
    id: 26,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-26.jpg",
  },
  {
    id: 27,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-27.jpg",
  },
  {
    id: 28,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-28.jpg",
  },
  {
    id: 29,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-29.jpg",
  },
  {
    id: 30,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-30.jpg",
  },
  {
    id: 31,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-31.jpg",
  },
  {
    id: 32,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-32.jpg",
  },
  {
    id: 33,
    category: "Innovative",
    year: 2024,
    image: "/images/documentation/IIT2024-Innovative-33.jpg",
  },
  {
    id: 34,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-1.jpg",
  },
  {
    id: 35,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-2.jpg",
  },
  {
    id: 36,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-3.jpg",
  },
  {
    id: 37,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-4.jpg",
  },
  {
    id: 38,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-5.jpg",
  },
  {
    id: 39,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-6.jpg",
  },
  {
    id: 40,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-7.jpg",
  },
  {
    id: 41,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-8.jpg",
  },
  {
    id: 42,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-9.jpg",
  },
  {
    id: 43,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-10.jpg",
  },
  {
    id: 44,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-11.jpg",
  },
  {
    id: 45,
    category: "Coding",
    year: 2024,
    image: "/images/documentation/IIT2024-Coding-12.jpg",
  },
  {
    id: 46,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-1.jpg",
  },
  {
    id: 47,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-2.jpg",
  },
  {
    id: 48,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-3.jpg",
  },
  {
    id: 49,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-4.jpg",
  },
  {
    id: 50,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-5.jpg",
  },
  {
    id: 51,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-6.jpg",
  },
  {
    id: 52,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-7.jpg",
  },
  {
    id: 53,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-8.jpg",
  },
  {
    id: 54,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-9.jpg",
  },
  {
    id: 55,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-10.jpg",
  },
  {
    id: 56,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-11.jpg",
  },
  {
    id: 57,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-12.jpg",
  },
  {
    id: 58,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-13.jpg",
  },
  {
    id: 59,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-14.jpg",
  },
  {
    id: 60,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-15.jpg",
  },
  {
    id: 61,
    category: "Obstacle",
    year: 2024,
    image: "/images/documentation/IIT2024-Obstacle-16.jpg",
  },
  {
    id: 62,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-1.jpg",
  },
  {
    id: 63,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-2.jpg",
  },
  {
    id: 64,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-3.jpg",
  },
  {
    id: 65,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-4.jpg",
  },
  {
    id: 66,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-5.jpg",
  },
  {
    id: 67,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-6.jpg",
  },
  {
    id: 68,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-7.jpg",
  },
  {
    id: 69,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-8.jpg",
  },
  {
    id: 70,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-9.jpg",
  },
  {
    id: 71,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-10.jpg",
  },
  {
    id: 72,
    category: "Sumo",
    year: 2024,
    image: "/images/documentation/IIT2024-Sumo-11.jpg",
  },
  {
    id: 73,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-1.jpg",
  },
  {
    id: 74,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-2.jpg",
  },
  {
    id: 75,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-3.jpg",
  },
  {
    id: 76,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-4.jpg",
  },
  {
    id: 77,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-5.jpg",
  },
  {
    id: 78,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-6.jpg",
  },
  {
    id: 79,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-7.jpg",
  },
  {
    id: 80,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-8.jpg",
  },
  {
    id: 81,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-9.jpg",
  },
  {
    id: 82,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-10.jpg",
  },
  {
    id: 83,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-11.jpg",
  },
  {
    id: 84,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-12.jpg",
  },
  {
    id: 85,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-13.jpg",
  },
  {
    id: 86,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-14.jpg",
  },
  {
    id: 87,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-15.jpg",
  },
  {
    id: 88,
    category: "Student Symposium",
    year: 2024,
    image: "/images/documentation/IIT2024-Symposium-16.jpg",
  },
];
